import { polygon } from "viem/chains";
import { createPublicClient } from "viem";
import { createPolygonTransport } from "@/lib/polygonRpc";

const publicClient = createPublicClient({
  chain: polygon,
  transport: createPolygonTransport()
});

export interface CreatorReputation {
  trustScore: number;
  previousLaunches: number;
  averageRoi: number;
  lastVerified: Date;
  isVerified: boolean;
}

export const fetchCreatorReputation = async (creatorAddress: string): Promise<CreatorReputation> => {
  // For demonstration, we're getting the creator's transaction count as a proxy for experience
  const txCount = await publicClient.getTransactionCount({
    address: creatorAddress as `0x${string}`
  });

  // Calculate a trust score based on transaction history
  const trustScore = Math.min(Math.floor((txCount / 100) * 100), 100);

  // In a real implementation, you would fetch this data from your backend
  // For now, we'll derive some values from the transaction count
  return {
    trustScore,
    previousLaunches: Math.floor(txCount / 50),
    averageRoi: 234, // This would come from actual trading data
    lastVerified: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    isVerified: txCount > 50
  };
};
